"use client"

import { Video } from "@/app/generated/prisma"
// import VideoPlayer from "@/components/shows/videoPlayer"
import { Play } from "lucide-react"
import dynamic from "next/dynamic"
import Image from "next/image"
import { useState } from "react"

const VideoPlayer = dynamic(() => import("@/components/shows/videoPlayer"), { ssr: false, loading: () => <div /> })

const FeaturedShowClient = ({ mostRecentShow }: { mostRecentShow: Video | null }) => {
   const [videoStarted, setVideoStarted] = useState(false)
   return (
      <>
         {!videoStarted ? (
            <div className="group relative aspect-video overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 to-gray-800 shadow-2xl">
               <Image
                  src={
                     mostRecentShow
                        ? (mostRecentShow.thumbnails as any)?.high?.url
                        : "https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrg"
                  }
                  alt="Chomp Show thumbnail"
                  className=" object-cover opacity-80"
                  fill
               />
               <div className="absolute inset-0 flex items-center justify-center bg-orange-600/30">
                  <div className="text-center text-white">
                     <button
                        onClick={() => setVideoStarted(true)}
                        className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-white/30 backdrop-blur-md transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-500"
                        aria-label="Play latest episode"
                     >
                        <Play className="ml-1 h-10 w-10 text-white drop-shadow" />
                     </button>
                     <h3 className="mb-2 text-2xl font-bold">The Chomp Show</h3>
                     <p className="text-lg opacity-90">Latest Episode Available</p>
                  </div>
               </div>
            </div>
         ) : (
            <div className="aspect-video  rounded-2xl bg-gray-900">
               <div className="z-100 aspect-video w-full overflow-hidden rounded-xl">
                  <VideoPlayer url={`https://www.youtube.com/watch?v=${mostRecentShow?.videoId}`} />
               </div>
            </div>
         )}
      </>
   )
}

export default FeaturedShowClient
